import './analyticsSelectors.scss'
import clsx from 'clsx'
import { SelectDropdown } from '@/shared/ui'
import { DateRangePicker } from '@/shared/components'
import {
    detalizationSortOptions,
    lineDateSortOptions,
    trafficSourceSortOptions,
    usersSortOptions,
    DetalizationOptionType,
    TrafficSourceOptionType,
    UsersSortOptionType,
    SubscriberStatusSortOptionType,
    subscriberStatusSortOptions,
    LineDateSortOptionType,
} from '../../constants'

interface AnalyticsSelectorsProps {
    lineDate?: LineDateSortOptionType | null
    trafficSource?: TrafficSourceOptionType
    detalization: DetalizationOptionType
    users: UsersSortOptionType
    subscribers: SubscriberStatusSortOptionType
    datePicker: {
        startDate: string
        endDate: string
    }
    onLineDateSelect?: (value: LineDateSortOptionType) => void
    onTrafficSourceSelect?: (status: TrafficSourceOptionType) => void
    onDetalizationSelect: (status: DetalizationOptionType) => void
    onUsersSelect: (status: UsersSortOptionType) => void
    onSubscribersSelect: (status: SubscriberStatusSortOptionType) => void
    onDateChange: {
        onFromDateChange: (date: string) => void
        onToDateChange: (date: string) => void
    }
    mode: 'Retention' | 'InviteLinks' | 'Audience'
}

export const AnalyticsSelectors = ({
    trafficSource,
    detalization,
    users,
    subscribers,
    datePicker,
    lineDate,
    onLineDateSelect,
    onTrafficSourceSelect,
    onDetalizationSelect,
    onUsersSelect,
    onSubscribersSelect,
    onDateChange,
    mode,
}: AnalyticsSelectorsProps) => {
    const handleLineDateSelect = (value: LineDateSortOptionType) => {
        if (!onLineDateSelect) return
        onLineDateSelect(value)
    }
    const handleTrafficSourceSelect = (status: TrafficSourceOptionType) => {
        if (!onTrafficSourceSelect) return
        onTrafficSourceSelect(status)
    }
    const handleDetalizationSelect = (status: DetalizationOptionType) => {
        onDetalizationSelect(status)
    }
    const handleUsersSelect = (status: UsersSortOptionType) => {
        onUsersSelect(status)
    }

    const handleSubscribersSelect = (
        status: SubscriberStatusSortOptionType
    ) => {
        onSubscribersSelect(status)
    }
    return (
        <div className="analytics-selectors">
            {(mode === 'InviteLinks' || mode === 'Audience') && (
                <div className="analytics-selectors__line">
                    {lineDateSortOptions.map((option) => (
                        <span
                            key={option.value}
                            className={clsx('analytics-selectors__line-item', {
                                selected: lineDate?.label === option.label,
                            })}
                            onClick={() => handleLineDateSelect(option)}
                        >
                            {option.label}
                        </span>
                    ))}
                </div>
            )}
            {(mode === 'Retention' || mode === 'Audience') && trafficSource && (
                <SelectDropdown
                    value={trafficSource.value}
                    options={trafficSourceSortOptions}
                    onSelect={handleTrafficSourceSelect}
                />
            )}
            <DateRangePicker
                startDate={datePicker.startDate}
                endDate={datePicker.endDate}
                onFromDateChange={onDateChange.onFromDateChange}
                onToDateChange={onDateChange.onToDateChange}
            />
            {mode !== 'Audience' && (
                <SelectDropdown
                    className='max-w-[207px]'
                    value={detalization.value}
                    options={detalizationSortOptions}
                    onSelect={handleDetalizationSelect}
                />
            )}

            <SelectDropdown
                value={users.value}
                options={usersSortOptions}
                onSelect={handleUsersSelect}
                className='max-w-[207px]'
            />
            {mode === 'Audience' && (
                <SelectDropdown                    
                    value={subscribers.value}
                    options={subscriberStatusSortOptions}
                    onSelect={handleSubscribersSelect}
                />
            )}
        </div>
    )
}
